// Root-domain `tm_caid` cookie written by MyAccount, SSO, Activation and MyDashboard
// so GTM reads the signed-in account.
// WRITE-ONLY: for GTM only. Never read this cookie for any business logic.
// Every exported function swallows its own errors: tracking must never break login.
// Spec: https://trendmicro.atlassian.net/wiki/spaces/WE/pages/2971633597
import { resolveCookieDomain } from '@/utilities/tmLangCookie';

const COOKIE_NAME = 'tm_caid';
const MAX_AGE_SECONDS = 60 * 60 * 24; // 24 hours, restarted on every write
const FULL_CAID = /^\d+\.[0-9a-f]+$/; // "71233928.c43c584f1e"

const getCookieDomain = () =>
  resolveCookieDomain(window.location.hostname, process.env.TM_LANG_COOKIE_DOMAINS);

export const buildTmCaidCookie = (value, maxAge, domain) =>
  `${COOKIE_NAME}=${value}; Path=/; Max-Age=${maxAge}; Secure; SameSite=Lax` +
  (domain ? `; Domain=${domain}` : '');

/** Write only a full "<id>.<signature>" value; anything else (digits only, BEUID) is ignored. */
export const writeTmCaid = (fullCaid) => {
  try {
    if (!fullCaid || !FULL_CAID.test(fullCaid)) return;
    const domain = getCookieDomain();
    // Drop a possible host-only cookie first: it would shadow the root-domain value
    // shared with the sibling services (Domain is part of a cookie's key).
    if (domain) document.cookie = buildTmCaidCookie('', 0);
    document.cookie = buildTmCaidCookie(fullCaid, MAX_AGE_SECONDS, domain);
  } catch (err) {
    console.debug('tm_caid: write skipped', err);
  }
};

export const clearTmCaid = () => {
  try {
    const domain = getCookieDomain();
    document.cookie = buildTmCaidCookie('', 0);
    if (domain) document.cookie = buildTmCaidCookie('', 0, domain);
  } catch (err) {
    console.debug('tm_caid: clear skipped', err);
  }
};
